/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const DisabledParser = /* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('disabled')],
]);
export class Disabled extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return DisabledParser.decode(input).map(res => new Disabled(res));
    }
    static unsafeDecode(input) {
        return Disabled.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return DisabledParser.encode(data);
    }
    static schema() {
        return DisabledParser.schema();
    }
}
